import React, {useRef} from 'react';
import {FaTimes} from "react-icons/fa";
import InputForm from "../../../../components/input/input-form.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import Button from "../../../../components/button/button.jsx";
import optionsUtils from "../../../../utils/options-utils.js";
import {MaskDefault} from "../../../../utils/mask.js";
import {loadCities, loadNeighborhoods, loadStreets} from "../utils/installer-utils.js";
import defaultLogo from "../../../../../public/img/logo-sentry/sw.s.logo.svg";

const InstallerCorporationStep = ({form, onChange, onCity, timezone, logoPreview, onLogoChange, onLogoRemove, onOpenMap}) => {
    const fileRef = useRef(null);

    return (
        <div className={"flex gap-4"}>
            <div className={"grid grid-cols-12 gap-4 w-9/12 h-fit"}>
                <div className={"col-span-6"}>
                    <InputForm
                        id={"name"}
                        label={"Nome da entidade *"}
                        value={form.name}
                        onChange={onChange}
                    />
                </div>

                <div className={"col-span-6"}>
                    <SelectComponent
                        isAsync
                        cacheOptions
                        defaultOptions={[]}
                        label={"Município *"}
                        loadOptions={loadCities}
                        value={optionsUtils.getValue(form.city)}
                        onChange={onCity}
                    />
                </div>

                <div className={"col-span-8"}>
                    <SelectComponent
                        isAsync
                        cacheOptions
                        defaultOptions={[]}
                        label={"Logradouro *"}
                        loadOptions={loadStreets}
                        value={optionsUtils.getValue(form.address)}
                        onChange={(option) => onChange({target: {id: "address", value: option?.value ?? ""}})}
                    />
                </div>

                <div className={"col-span-4"}>
                    <InputForm
                        id={"number"}
                        type={"number"}
                        label={"Número *"}
                        value={form.number}
                        onChange={onChange}
                    />
                </div>

                <div className={"col-span-8"}>
                    <SelectComponent
                        isAsync
                        cacheOptions
                        defaultOptions={[]}
                        label={"Bairro *"}
                        loadOptions={loadNeighborhoods}
                        value={optionsUtils.getValue(form.neighborhood)}
                        onChange={(option) => onChange({target: {id: "neighborhood", value: option?.value ?? ""}})}
                    />
                </div>

                <div className={"col-span-4"}>
                    <InputForm
                        id={"phone"}
                        label={"Telefone"}
                        value={form.phone}
                        mask={MaskDefault.phone}
                        onChange={onChange}
                    />
                </div>

                <div className={"col-span-8"}>
                    <InputForm
                        id={"institutional_email"}
                        type={"email"}
                        label={"E-mail institucional"}
                        value={form.institutional_email}
                        onChange={onChange}
                    />
                </div>

                <div className={"col-span-4"}>
                    <InputForm id={"timezone"} label={"Fuso horário"} value={timezone} disabled />
                </div>

                <div className={"col-span-4"}>
                    <InputForm
                        id={"latitude"}
                        label={"Latitude"}
                        value={form.latitude}
                        onChange={onChange}
                    />
                </div>

                <div className={"col-span-4"}>
                    <InputForm
                        id={"longitude"}
                        label={"Longitude"}
                        value={form.longitude}
                        onChange={onChange}
                    />
                </div>

                <div className={"col-span-4 content-center"}>
                    <Button className={"w-full"} onClick={onOpenMap}>Mapa</Button>
                </div>
            </div>

            <div className={"w-3/12"}>
                <label className={"text-[13px] text-[#4f4f4f]"}>Logo da corporação</label>

                <div
                    className={"relative mt-1 h-[180px] w-full rounded border border-[#e0e0e0] bg-center bg-no-repeat bg-contain"}
                    style={{backgroundImage: `url(${logoPreview ?? defaultLogo})`}}
                >
                    {!!logoPreview && (
                        <Button
                            target={"danger"}
                            title={"Remover logo"}
                            className={"absolute top-1 right-1"}
                            onClick={() => {
                                onLogoRemove();
                                if (fileRef.current) fileRef.current.value = "";
                            }}
                        >
                            <FaTimes />
                        </Button>
                    )}
                </div>

                <input
                    ref={fileRef}
                    id={"logo-corporation"}
                    type={"file"}
                    className={"hidden"}
                    accept={"image/png, image/jpeg"}
                    onChange={(event) => onLogoChange(event.target.files?.[0])}
                />

                <Button className={"w-full mt-2"} onClick={() => fileRef.current?.click()}>
                    Selecionar logo
                </Button>
            </div>
        </div>
    );
};

export default InstallerCorporationStep;
